import { combineReducers } from "redux";
import auth from "./auth/reducer";
import client from "./client/reducer";
import action from "./action/reducer";
import admin from "./admin/reducer";
import manager from "./manager/reducer";
import stats from "./stats/reducer";
import randomCoffee from "./randomCoffee/reducer";
import poll from "./poll/reducer";
import token from "./token/reducer";

export const allReducersName = [
  "auth",
  "client",
  "action",
  "admin",
  "manager",
  "stats",
  "randomCoffee",
  "poll",
  "token"
];

const rootReducer = combineReducers({
  auth,
  client,
  action,
  admin,
  manager,
  stats,
  randomCoffee,
  poll,
  token
});

export default rootReducer;
